import { Auction } from '@/api';

export function getBuyNowAmount(auction: Auction): string {
    const { buy_now_amount: amount, promotion } = auction;

    if (!amount) {
        return '0.00';
    }

    // Check if promotion is active
    if (promotion?.amount && promotion.expiration) {
        const expirationDate = new Date(promotion.expiration);
        if (expirationDate > new Date()) {
            return promotion.amount;
        }
    }

    // Return the buy-now amount if no active promotion
    return amount;
}
